import { FieldDescriptor } from '../types/modal/FieldDescriptor';
import { AssignmentRow } from '../types/assignment/AssignmentGetResponse';

export const ASSIGNMENT_HEADER = [
  { label: '社員コード', sortable: false, sortKey: '', width: '200px' },
  { label: '氏名', sortable: false, sortKey: '', width: '250px' },
  { label: '操作', sortable: false, sortKey: '', width: '150px' },
];

export const ASSIGNMENT_DELETE_FIELDS: FieldDescriptor<AssignmentRow>[] = [
  { label: '社員コード', key: 'employeeCode', type: 'text' },
  { label: '氏名', key: 'name', type: 'text' },
];
